// extracted by mini-css-extract-plugin
export default {"wrapper":"checkbox_wrapper__qqOUG","header":"checkbox_header__hAQqw"};